import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Constant Session Planning',
  description: 'You spend hours every week trying to create new training sessions that are safe, effective, and appropriate for different dogs — from complete beginners to reactive cases that seem impossible to manage.'
}, {
  emoji: '⚠️',
  title: 'Fear of Doing Too Much... or Too Little',
  description: 'You constantly wonder if an exercise is too advanced, too simple, or not appropriate for the dog in front of you — especially when dealing with fear-based reactivity, frustration, or aggression.'
}, {
  emoji: '📚',
  title: 'Information Everywhere',
  description: 'You find techniques and exercises online, but nothing is organized into a complete training system you can actually follow session after session with full confidence.'
}, {
  emoji: '😩',
  title: 'Mental Exhaustion',
  description: 'Between planning sessions, managing reactive episodes, communicating with owners, and staying on top of behavioral theory, you have little time left to focus on what truly matters: helping dogs live calmer, happier lives.'
}];
export function PainSection() {
  return <section className="py-7 px-4 sm:px-6 bg-brand-beige" data-id="element-113">
      <h2 className="text-2xl sm:text-3xl font-heading font-black text-center text-brand-green mb-2 uppercase leading-tight" data-id="element-114">
        DO YOU RECOGNIZE THIS?
      </h2>

      <p className="text-sm sm:text-base text-brand-ink font-medium text-center mb-5 leading-snug max-w-xl mx-auto" data-id="element-115">
        You love working with dogs, but does training preparation consume your
        entire week?
        <span className="text-brand-brown font-bold mt-1 block" data-id="element-116">
          If you work as a dog trainer — or if you're a dog owner struggling
          with a reactive, anxious, or disobedient dog — you probably know one
          of these situations:
        </span>
      </p>

      <div className="flex flex-col gap-3" data-id="element-117">
        {pains.map((pain, i) => <div key={i} className="bg-white p-4 rounded-md border-l-4 border-brand-brown shadow-sm flex gap-3 items-start" data-id="element-118">
            <div className="text-2xl leading-none shrink-0 mt-0.5" data-id="element-119">
              {pain.emoji}
            </div>
            <div data-id="element-120">
              <h3 className="text-sm font-bold text-brand-green mb-1 uppercase tracking-tight" data-id="element-121">
                {pain.title}
              </h3>
              <p className="text-brand-ink/80 text-sm leading-snug" data-id="element-122">
                {pain.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}